var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-text',{staticClass:"pa-0",style:(`height: ${_vm.height}px; overflow: auto`)},[_c('a-table-f-data2',{ref:'table-statusHistory',attrs:{"dataTable":_vm.data,"useQuery":false,"model":_vm.model,"searchable":false,"defaults":{
        filters: {},
        sort: { key: 'id', order: 'DESC' },
        paramName: 'statusHistory',
      }},on:{"click":function($event){return _vm.onClickRow($event, _vm.t)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }